<template>
  <div :class="$style['pt-coupon-detail']" v-loading="importLoading">
      <pt-page-title title="优惠劵详情"></pt-page-title>
      <pt-sub-title title="优惠劵信息"></pt-sub-title>
      <table :class="$style['coupon-message']" v-loading="loading">
          <pt-form-list-item label="优惠劵名称：">
              {{couponData.name}}
          </pt-form-list-item>
           <pt-form-list-item label="发放数量：">
              {{coupon_detail.limit ? coupon_detail.amount : '不限'}}
          </pt-form-list-item>
           <pt-form-list-item label="使用形式：">
              {{coupon_detail.used_type}}
          </pt-form-list-item>
           <pt-form-list-item label="已领取数量：">
              {{coupon_detail.limit ? (coupon_detail.amount - coupon_detail.surplusAmount) : '不限数量的优惠券暂未记录已领取数量'}}
          </pt-form-list-item>
           <pt-form-list-item label="优惠形式：">
              {{couponData.discount_show_shape}}
          </pt-form-list-item>
           <pt-form-list-item label="使用门槛：">
              {{couponData.thresholdOf_amount?'满'+couponData.thresholdOf_amount+'元可用':'无门槛'}}
          </pt-form-list-item>
           <pt-form-list-item label="适用商品：">
               <div class="page-background" v-if="couponData.goodsInfo&&couponData.goodsInfo.length>0">
                  <table class="goods-coupon-message-table">
                      <tr>
                          <td>商品名称</td>
                          <td>价格（元）</td>
                      </tr>
                       <tr v-for="(item,index) in couponData.goodsInfo" :key="index">
                        <td>{{item.goodsDTO&&item.goodsDTO.goodsData&&item.goodsDTO.goodsData.name}}</td>
                        <td>{{item.goodsDTO.goodsData.finalPrice && item.goodsDTO.goodsData.finalPrice / 100}}</td>
                    </tr>
                  </table>
                </div>
                <template v-else>
                  {{allGoodsBelong}}
                </template>
          </pt-form-list-item>
          <!-- <pt-form-list-item label="专属标签："></pt-form-list-item> -->
          <pt-form-list-item label="卡劵标题：">
              {{couponData.title}}
          </pt-form-list-item>
          <pt-form-list-item label="卡劵副标题：">
              {{couponData.subtitle?couponData.subtitle:'--'}}
          </pt-form-list-item>
          <pt-form-list-item label="有效期：">
              {{coupon_detail.validity_date}}
          </pt-form-list-item>
          <pt-form-list-item label="使用说明：">
              <div v-html="couponData.instruction" :class="$style.instruction"></div>
          </pt-form-list-item>
           <pt-form-list-item label="审核状态：">
               {{coupon_detail.coupon_status}}
           </pt-form-list-item>
            <pt-form-list-item label="申请人：" v-if="isShoweEditor">
               {{editorInfo.operatorName}}
           </pt-form-list-item>
           <template v-if="isShowAuditor">
           <pt-form-list-item label="审核人：">
               {{auditInfo.operatorName}}
           </pt-form-list-item>
           <pt-form-list-item label="审核时间：">
               {{coupon_detail.audit_time}}
           </pt-form-list-item>
           </template>
           <pt-form-list-item label="驳回理由：" v-if="coupon_detail.status==='REJECTION'&&coupon_detail.rejectedReason">
               {{coupon_detail.rejectedReason}}
           </pt-form-list-item>
           <pt-form-list-item label="第三方兑换码列表：" v-if="couponData.usedType === 'OFFLINE'">
               <a :href="$privateResourcesUrl+coupon_detail.codeExcel" target="_blank">{{coupon_detail.codeExcel.split('/')[1].split('-')[1]}}</a>
           </pt-form-list-item>
           <pt-form-list-item label="适用地区：" v-if="couponData.usedType === 'OFFLINE'">
               {{address.toString(address, ",")}}
           </pt-form-list-item>
      </table>
        <pt-sub-title title="发放/领取设置"></pt-sub-title>
        <table :class="$style['coupon-message']">
            <pt-form-list-item label="发放方式：">
                {{couponDetail.publishType}}
            </pt-form-list-item>
             <pt-form-list-item label="发放对象：" v-if="couponDetail.grantType==='GRANT'||couponDetail.grantType==='RECEIVE'">
                 {{couponDetail.grantObj}}
             </pt-form-list-item>
             <pt-form-list-item label="已选择用户：" v-if="couponDetail.grantObject==='DESIGNATED_USER'">
                <template v-if="couponDetail.mallUserQueryText">
                {{couponDetail.mallUserQueryText}}
                </template>
                <div :class="$style['select-user-name']" v-if="designatedUserInfo&&designatedUserInfo.length">
                    <span style="color:#000!important">已选择 {{firstUserName}} {{designatedUserInfo.length > 1 ? ('等'  +designatedUserInfo.length +'位用户...') : ''}}</span>
                    <el-button type="text" @click="viewUser">查看</el-button>
                </div>
                <div :class="$style['select-user-name']" v-if="importedCustomerTotal">
                    <span style="color:#000!important">已导入 {{importedCustomerFirstName}} {{importedCustomerTotal> 1 ? ('等'  +importedCustomerTotal +'位用户...') : ''}}</span>
                    <el-button type="text" @click="viewUserOfImport">查看</el-button>
                </div>
             </pt-form-list-item>
              <pt-form-list-item label="C端领取链接：" v-if="couponDetail.grantType==='RECEIVE'&&coupon_detail.status==='ACTIVATED'">
                <div :class="$style['coupon-url-copy']">
                  <div></div>
                <div :class="$style['goods-url-text']">/my-coupon/false/true/{{couponDetail.id}}</div>
                <pt-copy-button :copyContent="'/my-coupon/false/true/'+couponDetail.id" text="复制"></pt-copy-button>
                </div>
             </pt-form-list-item>
        </table>
         <el-dialog :visible="isViewUser" :class="$style[isImport?'user-dialog':'default-dialog']" :title="dialog_title"  @close="closeDialog">
       <select-view-user v-if="isViewUser" :isImport="isImport" :userListId="userListId" :pageSize="5"  :userIds="whiteListSpecificUserIds"> </select-view-user>
      </el-dialog>
  </div>
</template>

<script>
import { formatAllGoodsBelong } from '../../pt-promotion-coupon/promotion-option'
import selectViewUser from 'cps/customer-manage/select-view-user.vue'
// 组件class前缀
const prefixCls = 'pt-coupon-detail'

export default {
  name: 'pt-coupon-detail',
  components: {
    selectViewUser
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    couponData () {
      return this.coupon_detail.couponData || {}
    },
    allGoodsBelong () {
      if (this.couponData.couponBelong) {
        return this.couponData.couponBelong && this.couponData.couponBelong.length > 0 ? formatAllGoodsBelong(this.couponData.couponBelong[0]) : ''
      } else {
        return '优惠券数据错误'
      }
    },
    // s是否显示申请人信息
    isShoweEditor () {
      return this.coupon_detail.status !== 'WAITING_COMMIT'
    },
    // 是否先审核人信息
    isShowAuditor () {
      return this.coupon_detail.status !== 'WAITING_COMMIT' && this.coupon_detail.status !== 'WAITING_AUDIT'
    },
    // 审核人信息
    auditInfo () {
      return this.coupon_detail.auditInfo || {}
    },
    // 申请人信息
    editorInfo () {
      return this.coupon_detail.editorInfo || {}
    },
    designatedUserInfo () {
      return this.coupon_detail.designatedUserInfo || []
    },
    whiteListSpecificUserIds () {
      return (this.coupon_detail.mallUserCriteria && this.coupon_detail.mallUserCriteria.whiteListSpecificUserIds) || []
    },
    address () {
      return this.couponData.nationalUse ? '全国'
        : ((this.couponData.addressDetails && this.couponData.addressDetails.length) ? this.couponData.addressDetails.map(e => { return e.provinceName }) : '无')
    },
    firstUserName () {
      let res
      for (let i in this.designatedUserInfo) {
        if (this.designatedUserInfo[i].fullName) {
          res = this.designatedUserInfo[i].fullName
          break
        }
      }
      return res
    }
  },
  props: {
    couponDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      coupon_detail: this.couponDetail,
      selectUserList: null,
      importLoading: false,
      importedCustomerTotal: null,
      importedCustomerFirstName: null,
      isViewUser: false,
      dialog_title: null,
      isImport: false,
      userListId: null
    }
  },
  watch: {
    couponDetail: {
      handler: function (val) {
        this.coupon_detail = val
        if (val.mallUserCriteria && val.mallUserCriteria.whiteList && val.mallUserCriteria.whiteList.length) {
          let whiteList = val.mallUserCriteria.whiteList
          whiteList.forEach(item => {
            if (item.userListId) {
              this.userListId = item.userListId
              this.importedCustomer(item.userListId)
            }
          })
        }
      },
      deep: true
    }
  },
  methods: {
    viewUser () {
      this.isViewUser = true
      this.isImport = false
      this.dialog_title = '查看选择用户'
    },
    viewUserOfImport () {
      this.isViewUser = true
      this.isImport = true
      this.dialog_title = '查看导入用户'
    },
    closeDialog () {
      this.isViewUser = false
    },
    // 根据用户导入id，获取导入的用户列表
    importedCustomer (userListId) {
      let data = {
        pageable: {
          page: 0,
          size: 50
        },
        userListId: userListId
      }
      this.importLoading = true
      this.$store.dispatch('importedCustomer', data).then(res => {
        this.importedCustomerTotal = res.totalNumber
        let data = res.data
        for (let i in data) {
          this.importedCustomerFirstName = data[i].name
          break
        }
        this.importLoading = false
      }).catch(err => {
        this.importLoading = false
        this.$message.error(err || '获取导入用户列表失败')
      })
    }
  },
  created () {
    this.importedCustomer()
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import "~less/var.less";

.user-dialog{
  :global
  .el-dialog{
     width: 70%;
    min-width:1000PX;
    max-width:1200Px;
    }
}
.default-dialog{
  :global
  .el-dialog{
     width: 50%;
    min-width:600PX;
    max-width:800Px;
    }

}
.select-user-name{
    line-height: 40px;
    color:#000!important;
    &>span{
    color: #2D2D2D!important;
  }
    :global
    .el-button--text{
        margin-left: 10px;
    };
}
.pt-coupon-detail{

}
.coupon-message{
    padding: 0 40px 0 20px;
    box-sizing: border-box;
    width: 100%;
    display: block;
    :global
    tr{
        td{
            &:first{

            }
        }
        :first-child{
          color: @mainColor!important;
        }
        td{
            line-height: 40px;
        }
    }
    .instruction{
      :first-child{
          color:#000!important;
          margin:0
        }
      p{
          color:#000!important;
          margin:0
        }

    }
}

.goods-message-backgroud{

}

.coupon-url-copy{
  display: flex;
  :global
  .el-button{
    span{
      color: #fff!important
    }
    color: #fff
  }
}
.goods-url-text{
    margin-right: 10px;
    white-space: pre-wrap;
    justify-content:flex-start;
    flex:1;
    color: red !important;
}

</style>
<style lang="less">
.goods-coupon-message-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;

    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        line-height:50px!important;
        padding-bottom: 0!important;
}
}
.conpou-copy-button{
  color: #fff
}

</style>
